<template>
  <div>
    <MainNav />
    <main class="container py-4">
      <div class="mb-4">
        <h1 class="h3 mb-1">Tournée du collecteur</h1>
        <p class="text-muted mb-0">Cash à collecter et coffre du collecteur.</p>
      </div>

      <div v-if="loading" class="alert alert-secondary">Chargement…</div>
      <div v-else-if="forbidden" class="alert alert-danger">Réservé au collecteur ou au fondateur.</div>
      <div v-else-if="error" class="alert alert-danger">{{ error }}</div>

      <template v-else>
        <div class="row g-3 mb-4">
          <div class="col-6 col-md-3">
            <div class="card text-center shadow-sm"><div class="card-body">
              <div class="text-muted small">Coffre détenu</div>
              <div class="h4 mb-0">{{ euro(dash.held) }}</div>
            </div></div>
          </div>
          <div class="col-6 col-md-3">
            <div class="card text-center shadow-sm"><div class="card-body">
              <div class="text-muted small">À collecter</div>
              <div class="h4 mb-0">{{ euro(dash.total_to_collect) }}</div>
            </div></div>
          </div>
          <div class="col-6 col-md-3">
            <div class="card text-center shadow-sm"><div class="card-body">
              <div class="text-muted small">Relais à visiter</div>
              <div class="h4 mb-0">{{ dash.relays_to_visit }}</div>
            </div></div>
          </div>
          <div class="col-6 col-md-3">
            <div class="card text-center shadow-sm" :class="{ 'border-danger': dash.open_discrepancies > 0 }"><div class="card-body">
              <div class="text-muted small">Écarts ouverts</div>
              <div class="h4 mb-0">{{ dash.open_discrepancies }}</div>
            </div></div>
          </div>
        </div>

        <h2 class="h5 mb-2">Points relais</h2>
        <div v-if="dash.relays.length === 0" class="alert alert-success">Aucun cash à collecter.</div>
        <div v-else class="list-group shadow-sm">
          <div v-for="r in dash.relays" :key="r.service_point_id" class="list-group-item">
            <div class="d-flex justify-content-between align-items-center gap-3">
              <div>
                <strong>{{ r.name }}</strong>
                <div class="text-muted small">{{ r.city }} · {{ r.phone }}</div>
                <div v-if="Number(r.in_litigation) > 0" class="text-danger small">
                  En litige (gelé) : {{ euro(r.in_litigation) }}
                </div>
              </div>
              <span class="badge bg-primary fs-6">{{ euro(r.collectable) }}</span>
            </div>
          </div>
        </div>
      </template>
    </main>
  </div>
</template>

<script>
import axios from 'axios'
import MainNav from '@/components/MainNav.vue'

export default {
  name: 'CollectorDashboard',
  components: { MainNav },
  data() {
    return { loading: true, forbidden: false, error: '',
      dash: { held: '0', total_to_collect: '0', relays_to_visit: 0, open_discrepancies: 0, relays: [] } }
  },
  mounted() { this.load() },
  methods: {
    euro(v) { return `${Number(v).toFixed(2)} €` },
    async load() {
      this.loading = true; this.error = ''; this.forbidden = false
      try {
        const { data } = await axios.get('/api/v1/cash/collector/dashboard/')
        this.dash = data
      } catch (e) {
        if (e.response?.status === 403) this.forbidden = true
        else this.error = "Impossible de charger la tournée."
      } finally { this.loading = false }
    },
  },
}
</script>
